import { create } from 'zustand';
import { Module } from '../types/Module';
import { ModuleStatus } from '../types/enums/ModuleStatus';
import { CompensationPlan } from '../types/enums/CompensationPlan';
import { getModuleData, setDemoPlan } from '../utils/storage';

interface ModuleStore {
  data: Module | null;
  status: ModuleStatus;
}

interface ModuleActions {
  loadModule: (data: Module) => void;
  setStatus: (status: ModuleStatus) => void;
  updateCompensationPlan: (plan: CompensationPlan) => void;
}

const moduleData = getModuleData();

export const useModuleStore = create<ModuleStore & ModuleActions>(
  (set, get) => ({
    data: moduleData,
    status: ModuleStatus.Initial,

    loadModule: (data) => set({ data, status: ModuleStatus.Loaded }),
    setStatus: (status) => set({ status }),
    updateCompensationPlan: (plan) => {
      const currentData = get().data;
      const updatedData = Module.fromJson({
        ...currentData?.toJson(),
        compensationPlan: plan,
      });
      set({ data: updatedData });
      setDemoPlan(plan);
    },
  })
);

export function isModuleLoaded(): boolean {
  return useModuleStore.getState().status == ModuleStatus.Loaded;
}

export function getCompensationPlan(): CompensationPlan | undefined {
  return useModuleStore.getState().data?.compensationPlan;
}
